import { useRef } from 'react'
import type { LandingPersonaId } from './useLandingPersona'

const ORDER: LandingPersonaId[] = ['jarvis', 'ultron', 'ares', 'symbiote', 'friday']

/** Returns touch handlers that cycle persona on a horizontal swipe. */
export function useSwipePersona(
  personaId: LandingPersonaId,
  setPersonaId: (id: LandingPersonaId) => void,
) {
  const startX = useRef<number | null>(null)
  const startY = useRef<number | null>(null)

  const cycle = (dir: 1 | -1) => {
    const i = ORDER.indexOf(personaId)
    setPersonaId(ORDER[(i + dir + ORDER.length) % ORDER.length])
    if (typeof navigator !== 'undefined' && navigator.vibrate) navigator.vibrate(8)
  }

  return {
    onTouchStart: (e: React.TouchEvent) => {
      startX.current = e.touches[0].clientX
      startY.current = e.touches[0].clientY
    },
    onTouchEnd: (e: React.TouchEvent) => {
      if (startX.current == null || startY.current == null) return
      const dx = e.changedTouches[0].clientX - startX.current
      const dy = e.changedTouches[0].clientY - startY.current
      // Only horizontal swipes past threshold; ignore mostly-vertical (scroll).
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        cycle(dx < 0 ? 1 : -1) // swipe left → next identity
      }
      startX.current = null
      startY.current = null
    },
  }
}
